module.exports = __webpack_public_path__ + "img/works_jkl_btm_off.f22167ca.jpg";